import React from 'react';
import  {useState} from "react";
import DatePicker,{ registerLocale, setDefaultLocale } from "react-datepicker";
import moment from 'moment';
import 'moment/locale/pt-br';
import "react-datepicker/dist/react-datepicker.css";
import br from 'date-fns/locale/pt-BR';
registerLocale('br', br);

function TimeField(props) {

    let timeValue = '';
    if(props.value && props.value != ''){
        timeValue = moment(`2000-01-01 ${props.value}:00`).toDate();
    }

    let [value,updateValue] = useState(timeValue);
    let className = "form-control";

    const handleChange = element => {
      const target = {
        name:props.name,
        type: 'time',
        value: moment(element).format("HH:mm"),
      }
      updateValue(element);
      props.onChange({target:target});
    };

    if(props.error){
        className+=" is-invalid";
    }
    return (
        <div>
            {!props.readOnly && (
                <DatePicker
                    id={'id_'+props.name} 
                    name={props.name}
                    selected={value}
                    onChange={handleChange}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={15}
                    timeCaption="Time"
                    dateFormat="HH:mm"
                    className={className}
                />
            )}
            {props.readOnly && (
                <span>{moment(value).format("HH:mm")}</span>
            )}
            {props.error && (
                <span 
                    className="error invalid-feedback" 
                    style={{display:'inline'}}>
                        {props.error}
                </span>
            )}
        </div>
        
    );
}
export default TimeField;
